/** Excel / Sheets / Word vágólap HTML — táblázat kinyerése + email-barát inline stílusok. */

const TABLE_STYLE = "border-collapse:collapse;width:100%;margin:14px 0;font-size:14px;";
const CELL_STYLE = "border:1px solid #475569;padding:8px 10px;vertical-align:top;color:#e2e8f0;";
const HEADER_STYLE = `${CELL_STYLE}background:#1e293b;font-weight:bold;color:#f8fafc;`;

function styleTable(table) {
  if (!table.getAttribute("style")?.includes("border-collapse")) {
    const prev = table.getAttribute("style") || "";
    table.setAttribute("style", `${prev}${prev ? ";" : ""}${TABLE_STYLE}`);
  }
  table.querySelectorAll("th").forEach((cell) => {
    if (!cell.getAttribute("style")?.includes("border")) {
      cell.setAttribute("style", HEADER_STYLE);
    }
  });
  table.querySelectorAll("td").forEach((cell) => {
    if (!cell.getAttribute("style")?.includes("border")) {
      cell.setAttribute("style", CELL_STYLE);
    }
  });
}

export function normalizeInviteEmailTableHtml(html) {
  if (!html) return null;
  if (!/<table[\s>]/i.test(html)) {
    if (html.includes("\t")) return tsvToTableHtml(html);
    return null;
  }
  const doc = new DOMParser().parseFromString(html, "text/html");
  const tables = doc.querySelectorAll("table");
  if (!tables.length) return null;
  tables.forEach(styleTable);
  if (tables.length === 1) return tables[0].outerHTML;
  return Array.from(tables)
    .map((t) => t.outerHTML)
    .join("");
}

function escapeCell(text) {
  return String(text ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

/** Excel / Numbers gyakran csak TSV-t ad — HTML táblázattá alakítjuk. */
export function tsvToTableHtml(text) {
  const lines = (text || "").trim().split(/\r?\n/).filter(Boolean);
  if (lines.length < 1) return null;
  const rows = lines.map((line) => line.split("\t"));
  const cols = Math.max(...rows.map((r) => r.length));
  if (cols < 2 && rows.length < 2) return null;
  const head = rows[0];
  const body = rows.slice(1);
  let html =
    `<table cellpadding="0" cellspacing="0" style="${TABLE_STYLE}"><thead><tr>` +
    head.map((c) => `<th style="${HEADER_STYLE}">${escapeCell(c)}</th>`).join("") +
    "</tr></thead><tbody>";
  for (const row of body) {
    html += "<tr>";
    for (let i = 0; i < cols; i += 1) {
      html += `<td style="${CELL_STYLE}">${escapeCell(row[i] ?? "")}</td>`;
    }
    html += "</tr>";
  }
  html += "</tbody></table>";
  return html;
}

export function clipboardHtmlFromEvent(event) {
  const dt = event?.clipboardData;
  if (!dt) return null;
  const html = dt.getData("text/html");
  if (html?.trim()) return html;
  const plain = dt.getData("text/plain");
  if (plain?.includes("\t")) {
    return tsvToTableHtml(plain);
  }
  return null;
}

export async function readHtmlFromSystemClipboard() {
  if (!navigator.clipboard?.read) return null;
  try {
    const items = await navigator.clipboard.read();
    for (const item of items) {
      if (item.types.includes("text/html")) {
        const blob = await item.getType("text/html");
        return blob.text();
      }
    }
  } catch {
    return null;
  }
  return null;
}
